import Image from 'next/image';
import styled from 'styled-components';

import useDevice from '@hooks/useDevice';

function Partners() {
  const { isMobile } = useDevice();

  return (
    <Wrapper>
      <Row>
        <StyledImage
          height={19}
          width={100}
          alt="uber-freight.webp"
          src="/images/uber-freight.webp"
        />

        <StyledImage
          height={15}
          width={66}
          alt="echo-bw.webp"
          src="/images/echo-bw.webp"
        />

        <StyledImage
          height={33}
          width={100}
          alt="kerry-bw.webp"
          src="/images/kerry-bw.webp"
        />

        {!isMobile && (
          <StyledImage
            height={31}
            width={100}
            alt="cqc-bw.webp"
            src="/images/cqc-bw.webp"
          />
        )}
      </Row>

      <Row>
        <StyledImage
          height={15}
          width={118}
          alt="arrive-logistics-bw.webp"
          src="/images/arrive-logistics.png"
        />

        <StyledImage
          height={15}
          width={41}
          alt="rxo.webp"
          src="/images/rxo.webp"
        />

        <StyledImage
          height={30}
          width={102}
          alt="sherwin-williams-bw.webp"
          src="/images/sherwin-williams-bw.webp"
        />

        {!isMobile && (
          <StyledImage
            height={26}
            width={101}
            alt="lineage.webp"
            src="/images/lineage-bw.webp"
          />
        )}
      </Row>
    </Wrapper>
  );
}

const Row = styled.div`
  height: 30px;
  overflow: hidden;

  display: flex;
  align-items: center;

  mask-image: linear-gradient(to right, #00000000, #000000, #00000000);
`;

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
`;

const StyledImage = styled(Image)`
  margin: 0 10px;

  &:last-child {
    margin-right: 0;
  }

  &:first-child {
    margin-left: 0;
  }
`;

export default Partners;
